

import { Component, Prop, Vue } from 'vue-property-decorator';
import InternalTicketsRepositoryInterface, { SettingType } from '@/services/Internal-Tickets/interfaces';

@Component({
  inject: ['internalTicketsRepository'],
})
export default class CreateSetting extends Vue {

  public reporterId: number;
  public dialog = false;
  @Prop() settingType: SettingType;

  public name = '';
  public color = '';

  private readonly internalTicketsRepository: InternalTicketsRepositoryInterface;


  public async createSetting(): Promise<void> {
    const dto = {
      name: this.name,
      color: this.color,
    };
    try {
      await this.internalTicketsRepository.createSetting(this.settingType,dto)
      this.$emit('settingCreated',this.settingType)
      this.dialog = false;
    } catch (e) {
      this.$errorDialog.show('Failed to retrieve settings: ' + e.message);
    }
  }
}
